
import $ from "jquery";
import { IGlobalState } from "@/store";
import HEADER_MENU from "@/typings/app";
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { uploadFile } from "@/utils/aliOss";
import { useStore } from "vuex";
import { useDictList, setCurrentDictItem } from "@/hooks/dict";
import { IDictItem } from "@/typings/dict";
import { addOrModifyAppInfo } from "@/service/api";
import { useApplicationInfo } from "@/hooks/frontApp";

export default defineComponent({
  setup() {
    const formItemRef = ref<any>(null);
    const screenshotInput = ref<any>(null);
    const fileInput = ref<any>(null);

    const store = useStore<IGlobalState>();

    const router = useRouter();
    const state = reactive({
      stepNum: 1,
      stepList: [
        {
          sort: 1,
          title: "应用基础信息",
        },
        {
          sort: 2,
          title: "完成",
        },
      ],
      formItem: {
        id: router.currentRoute.value.query.appid,
        userId: store.state.user.id,
        title: "",
        logo: "",
        introduce: "",
        screenshot: "",
        categoryCode: "",
        categoryName: "",
        systemType: "",
        terminalType: "",
        useUserType: "",
        useScene: "",
        redirectUrl: "",
      },
      rules: {
        title: [{ required: true, message: "请输入应用名称", trigger: "blur" }],
        logo: [
          { required: true, message: "请上传应用图标", trigger: "change" },
        ],
        introduce: [
          { required: true, message: "请输入应用简介", trigger: "blur" },
        ],
        categoryCode: [
          { required: true, message: "请选择应用分类", trigger: "change" },
        ],
        systemType: [
          { required: true, message: "请选择适用系统", trigger: "change" },
        ],
        terminalType: [
          { required: true, message: "请选择适用终端", trigger: "change" },
        ],
        useGroup: [
          { required: true, message: "请选择使用群体", trigger: "change" },
        ]
      },
      terminalTypeList: [
        {
          value: "web",
          label: "网页端",
        },
        {
          value: "mobile",
          label: "手机端",
        },
        {
          value: "pc",
          label: "PC端",
        },
      ],
      useGroupList: [
        {
          value: "1",
          label: "老师",
        },
        {
          value: "2",
          label: "学生",
        },
        {
          value: "3",
          label: "家长",
        },
        {
          value: "-1",
          label: "其他",
        },
      ],
      showUnderline: false,
      appId: "",
      appPathTitle: ''
    });
    // 应用截图集合
    const screenshotArr = ref<string[]>([]);
    const selSystemTypeList = ref<string[]>([]);
    const selTerminalTypeList = ref<string[]>([]);
    const selUseGroupList = ref<string[]>([]);
    const dicts = computed(() => store.state.dict.dicts);
    // 当前选择的应用类别code
    const curDictCode = computed({
      get: () => store.state.dict.curDictCode,
      set: (val) => {
        store.state.dict.curDictCode = val;
      },
    });
    // 头部当前选中的菜单下标
    const headerMenuIndex = computed({
      get: () => store.state.app.headerMenuIndex,
      set: (val) => {
        store.state.app.headerMenuIndex = val;
      },
    });
    const application = computed(() => store.state.frontApp.application);
    /**
     * 根据appId 获取应用详情
     */
    const getApplicationInfo = async () => {
      await useApplicationInfo(store, state.formItem.id);
    };
    /**
     * 支持系统改变时触发
     */
    function systemTypeChange(value: string[]) {
      state.formItem.systemType = value.join(",");
      formItemRef.value.validateField("systemType");
    }
    /**
     * 支持端改变时触发
     */
    function terminalTypeChange(label: string[]) {
      const checkItemArr: string[] = [];
      for (let i = 0; i < label.length; i++) {
        const curItem = state.terminalTypeList.filter(
          (item) => item.label === label[i]
        );
        if (curItem.length > 0) {
          checkItemArr.push(curItem[0].value);
        }
      }
      state.formItem.terminalType = checkItemArr.join(",");
      formItemRef.value.validateField("terminalType");
    }
    /**
    * 支持使用群体改变时触发
    */
    function useGroupChange(label: string[]) {
      const checkItemArr: string[] = [];
      for (let i = 0; i < label.length; i++) {
        const curItem = state.useGroupList.filter(
          (item) => item.label === label[i]
        );
        if (curItem.length > 0) {
          checkItemArr.push(curItem[0].value);
        }
      }
      state.formItem.useUserType = checkItemArr.join(",");
      formItemRef.value.validateField("useGroup");
    }

    /**
     * 删除图片域名
     */
    function removeDomain() {
      if (state.formItem.logo) {
        state.formItem.logo = state.formItem.logo.substring(
          state.formItem.logo.indexOf("/aliba") + 1
        );
      }
      if (screenshotArr.value.length > 0) {
        for (let i = 0; i < screenshotArr.value.length; i++) {
          screenshotArr.value[i] = screenshotArr.value[i].substring(
            screenshotArr.value[i].indexOf("/aliba") + 1
          );
        }
        state.formItem.screenshot = screenshotArr.value.join(",");
      }
    }
    /**
     * 取消 跳转至我的应用列表
     */
    function cancel() {
      router.push("/myapp");
    }
    /**
     * 添加应用
     */
    function addApp() {
      formItemRef.value.validate(async (valid: boolean) => {
        if (valid) {
          removeDomain();
          const params = Object.assign({}, state.formItem);
          const result = await addOrModifyAppInfo(params);
          if (result.code == 1) {
            formItemRef.value.resetFields();
            curDictCode.value = "";
            if (!state.formItem.id) {
              state.stepNum = 2;
              state.appId = result.data;
            } else {
              ElMessage({ message: "修改成功", type: "success" });
              cancel();
            }
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          nextTick(() => {
            //滚动到第一个表单检验未通过的位置
            //第一个元素相对于文档偏移量
            const topOffsetPx = $(".el-form-item:eq(0)").offset().top;
            const domOffsetPx = $(".el-form-item__error:eq(0)").offset().top;
            // 目标元素相对于文档偏移量 - 第一个元素相对于文档偏移量 就是滚动条要滚动的距离
            const scrollTopPx = domOffsetPx - topOffsetPx;
            $(".dt-open-api-content").animate(
              {
                // 动画方式滚动过去
                scrollTop: scrollTopPx,
              },
              500
            );
          })
          return false;
        }
      });
    }
    /**
     * 删除应用图标
     */
    function clearnLogo() {
      state.formItem.logo = "";
    }
    /**
     * 删除应用截图
     */
    function clearnScreenshot(index: number) {
      screenshotArr.value.splice(index, 1);
    }
    /**
     * 点击上传图片来触发上传文件的input
     */
    function uploadLogoClick() {
      document.getElementById("uploadLogo")!.click();
    }
    function logoToUpload(e: any) {
      //获取文件信息
      const fileList: Array<File> = [...e.currentTarget.files];
      if (fileList) {
        for (let i = 0; i < fileList.length; i++) {
          const file = fileList[i];
          const fileName: string = file.name;
          const fileExt: string = fileName.substring(
            fileName.lastIndexOf(".") + 1,
            fileName.length
          );
          const maxSize: number = 5 * 1024 * 1024;
          if (file.size > maxSize) {
            ElMessage({
              message: "请上传文件大小不超过5MB的图片！",
              type: "error",
            });
            return;
          }
          console.log(fileExt);
          if (
            fileExt != "jpg" &&
            fileExt != "jpeg" &&
            fileExt != "bmp" &&
            fileExt != "png"
          ) {
            ElMessage({
              message: "请上传jpg、jpeg、bmp、png格式图片！",
              type: "error",
            });
            return;
          }

          uploadFile(
            file,
            "openapi/app/logo",
            "",
            "",
            (uploadState: boolean, filepath: string) => {
              if (uploadState) {
                state.formItem.logo =
                  store.state.app.aliyunPath + "/" + filepath;
                fileInput.value.value = "";
              }
            }
          );
        }
      }
    }
    /**
     * 点击上传应用截图来触发上传文件的input
     */
    function uploadScreenshotClick() {
      if (screenshotArr.value.length < 5) {
        document.getElementById("uploadScreenshot")!.click();
      } else {
        ElMessage({
          message: "应用截图只能上传五张图片！",
          type: "error",
        });
      }
    }
    function screenshotToUpload(e: any) {
      //获取文件信息
      const fileList: Array<File> = [...e.currentTarget.files];
      if (fileList) {
        for (let i = 0; i < fileList.length; i++) {
          const file = fileList[i];
          const fileName: string = file.name;
          const fileExt: string = fileName.substring(
            fileName.lastIndexOf(".") + 1,
            fileName.length
          );
          const maxSize: number = 5 * 1024 * 1024;
          if (file.size > maxSize) {
            ElMessage({
              message: "请上传文件大小不超过5MB的图片！",
              type: "error",
            });
            return;
          }
          if (
            fileExt != "jpg" &&
            fileExt != "jpeg" &&
            fileExt != "bmp" &&
            fileExt != "png"
          ) {
            ElMessage({
              message: "请上传jpg、jpeg、bmp、png格式图片！",
              type: "error",
            });
            return;
          }

          uploadFile(
            file,
            "openapi/app/screenshot",
            "",
            "",
            (uploadState: boolean, filepath: string) => {
              if (uploadState) {
                state.formItem.screenshot =
                  store.state.app.aliyunPath + "/" + filepath;
                screenshotArr.value.push(state.formItem.screenshot);
                screenshotInput.value.value = "";
              }
            }
          );
        }
      }
    }
    /**
     * 获取应用分类列表
     */
    const getCategoryData = async () => {
      await useDictList(store, 326, 1, 100);
    };
    /**
     * 根据字典编码获取字典对应名称
     */
    function findDictNameById(code: string) {
      const curDictItem: IDictItem[] = dicts.value.filter(
        (item) => item.dict_code === code
      );

      return curDictItem[0];
    }
    /**
     * 应用列表下拉框被改变时触发
     */
    async function onCategoryChange(code: string) {
      const curDictItem = findDictNameById(code);
      await setCurrentDictItem(store, curDictItem);
      state.formItem.categoryCode = curDictItem.dict_code;
      state.formItem.categoryName = curDictItem.dict_name;
      formItemRef.value.validateField("categoryCode");
    }
    /**
     * 跳转至我的应用列表或应用详情页
     */
    function gotoPage(name: string) {
      if (name === "appinfo") {
        router.push({ path: "/" + name, query: { appid: state.appId } });
      } else {
        router.push("/" + name);
      }
    }
    /**
    * 根据value查找对象的文本
    */
    const getTextByVal = (selTarget: any, targetLsit: any) => {
      const checkItemArr: string[] = [];
      const tempTerminalType = selTarget.split(",");
      for (let i = 0; i < tempTerminalType.length; i++) {
        const curItem = targetLsit.filter(
          (item: any) => item.value === tempTerminalType[i]
        );
        if (curItem.length > 0) {
          checkItemArr.push(curItem[0].label);
        }
      }
      return checkItemArr;
    }
    /**
     * 当修改应用时将应用信息赋值给表单参数
     */
    function initFormItemByEdit() {
      state.formItem.title = application.value.title;
      state.formItem.logo =
        store.state.app.aliyunPath + "/" + application.value.logo;
      state.formItem.introduce = application.value.introduce;
      state.formItem.screenshot = application.value.screenshot;
      state.formItem.categoryCode = application.value.categoryCode;
      state.formItem.categoryName = application.value.categoryName;
      state.formItem.systemType = application.value.systemType;
      state.formItem.terminalType = application.value.terminalType;
      state.formItem.useUserType = application.value.useUserType;
      state.formItem.redirectUrl = application.value.redirectUrl;
      if (application.value.screenshot) {
        const tempScreenshotArr = application.value.screenshot.split(",");
        for (let i = 0; i < tempScreenshotArr.length; i++) {
          screenshotArr.value.push(
            store.state.app.aliyunPath + "/" + tempScreenshotArr[i]
          );
        }
      }
      curDictCode.value = application.value.categoryCode;
      selSystemTypeList.value = state.formItem.systemType.split(",");
      selTerminalTypeList.value = getTextByVal(state.formItem.terminalType, state.terminalTypeList);
      selUseGroupList.value = getTextByVal(state.formItem.useUserType, state.useGroupList);
      state.formItem.useScene = application.value.useScene;
    }

    /**
     * 页面一开始加载
     */
    onMounted(async () => {
      headerMenuIndex.value = HEADER_MENU.PERSONAL;
      //获取应用分类列表
      await getCategoryData();
      // 修改应用时获取应用信息
      if (state.formItem.id) {
        await getApplicationInfo();
        initFormItemByEdit();
      }
      if (process.env.VUE_APP_FORM_KEY === 'gzopen') {
        state.appPathTitle = '应用地址';
      } else {
        state.appPathTitle = 'sso回调地址';
      }
    });
    return {
      ...toRefs(state),
      dicts,
      curDictCode,
      selSystemTypeList,
      selTerminalTypeList,
      selUseGroupList,
      screenshotArr,
      formItemRef,
      systemTypeChange,
      terminalTypeChange,
      useGroupChange,
      addApp,
      cancel,
      clearnLogo,
      clearnScreenshot,
      uploadLogoClick,
      logoToUpload,
      uploadScreenshotClick,
      screenshotToUpload,
      onCategoryChange,
      gotoPage,
      fileInput,
      screenshotInput,
    };
  },
});
